<template>
  <m-snackbar
    v-model="showSnack"
    type="text"
    v-bind="$attrs"
    :leading="true"
    v-on="$listeners" />
</template>

<script>
import Vue from 'vue'
import Snackbar from 'material-components-vue/dist/snackbar'

Vue.use(Snackbar)

export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      showSnack: this.value
    }
  },
  watch: {
    value () {
      this.showSnack = this.value
    }
  }
}
</script>

<style lang="scss">
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/snackbar/styles";

  .mdc-snackbar .mdc-snackbar__surface {
    min-width: initial;
  }
</style>
